import { SET_PROMOTION_LIST, UNSET_PROMOTION_LIST } from "@/store/mutation-types";

// initial state
const state = {
    getHrmPromotionList: [],
    editingPromotion: null,
}

const getters = {
    getHrmPromotionList(state){
        return state.getHrmPromotionList;
    },
    getEditingPromotion: (state) => { 
        return state.editingPromotion;
    },
}

const mutations = {
    [SET_PROMOTION_LIST](state, data) {
        state.getHrmPromotionList = data;
    },
    [UNSET_PROMOTION_LIST](state) {
        state.getHrmPromotionList = [];
    },
    setEditingPromotion(state, promotion) {
        state.editingPromotion = promotion;
    },
    clearEditingPromotion(state) {
        state.editingPromotion = null;
    }
}

const actions = {
    // Actions will be handled by the service layer
}

export default {
    state,
    getters,
    mutations,
    actions
}
